import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, Directive, NgModule } from '@angular/core';
import * as i2 from '@yourcause/common/i18n';
import { I18nModule } from '@yourcause/common/i18n';
import * as i1 from '@yourcause/common/notifier';
import { NotifierModule } from '@yourcause/common/notifier';

class BlockUiComponent {
    get blocking() {
        return this._blocking;
    }
    set blocking(value) {
        this.setBlocking(value);
    }
    constructor(notifier, i18n) {
        this.notifier = notifier;
        this.i18n = i18n;
        this._blocking = false;
        this.message = '';
    }
    setBlocking(value) {
        if (value && !this._blocking) {
            this.notifier.announce(this.i18n.translate('common:textLoading', {}, 'Loading'));
        }
        if (!value && this._blocking) {
            this.notifier.replaceAnnouncement(this.i18n.translate('common:textLoading', {}, 'Loading'), this.i18n.translate('common:textLoaded', {}, 'Loaded'));
        }
        this._blocking = value;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockUiComponent, deps: [{ token: i1.NotifierService }, { token: i2.I18nService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: BlockUiComponent, selector: "yc-block-ui", inputs: { blocking: "blocking", message: "message" }, ngImport: i0, template: "<div class=\"resolving\"\n  [class.not-visible]=\"!blocking\"\n  [attr.aria-live]=\"'polite'\"\n  [attr.aria-label]=\"'common:textLoading' | ycI18n: 'Loading'\"\n  [attr.aria-hidden]=\"!blocking\">\n  <div class=\"mask\"></div>\n  <div class=\"spinner\">\n    <img class=\"fa-spin\" \n      src=\"./assets/img/brand/yc-circle-logo.png\" \n      [alt]=\"'common:textLoading' | ycI18n: 'Loading'\">\n    <div *ngIf=\"message\"\n      class=\"mt-3 font-875-rem font-550\">\n      {{ message }}\n    </div>\n  </div>\n</div>\n\n<ng-content></ng-content>\n", styles: [".resolving{position:fixed;inset:0;z-index:99997;opacity:1;background-color:transparent;transition:opacity .15s ease-in-out;pointer-events:all}.resolving.not-visible{opacity:0;pointer-events:none}.resolving .mask{z-index:99998;height:100%;width:100%;background-color:#fff;opacity:.75;cursor:progress}.resolving .spinner{flex-direction:column;display:flex;z-index:99999;align-items:center;justify-content:center;background-color:transparent;width:100%;height:100%;position:fixed;top:0;left:0}.resolving .spinner img{height:3rem;filter:grayscale(100%)}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2.I18nPipe, name: "ycI18n" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockUiComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-block-ui', template: "<div class=\"resolving\"\n  [class.not-visible]=\"!blocking\"\n  [attr.aria-live]=\"'polite'\"\n  [attr.aria-label]=\"'common:textLoading' | ycI18n: 'Loading'\"\n  [attr.aria-hidden]=\"!blocking\">\n  <div class=\"mask\"></div>\n  <div class=\"spinner\">\n    <img class=\"fa-spin\" \n      src=\"./assets/img/brand/yc-circle-logo.png\" \n      [alt]=\"'common:textLoading' | ycI18n: 'Loading'\">\n    <div *ngIf=\"message\"\n      class=\"mt-3 font-875-rem font-550\">\n      {{ message }}\n    </div>\n  </div>\n</div>\n\n<ng-content></ng-content>\n", styles: [".resolving{position:fixed;inset:0;z-index:99997;opacity:1;background-color:transparent;transition:opacity .15s ease-in-out;pointer-events:all}.resolving.not-visible{opacity:0;pointer-events:none}.resolving .mask{z-index:99998;height:100%;width:100%;background-color:#fff;opacity:.75;cursor:progress}.resolving .spinner{flex-direction:column;display:flex;z-index:99999;align-items:center;justify-content:center;background-color:transparent;width:100%;height:100%;position:fixed;top:0;left:0}.resolving .spinner img{height:3rem;filter:grayscale(100%)}\n"] }]
        }], ctorParameters: () => [{ type: i1.NotifierService }, { type: i2.I18nService }], propDecorators: { blocking: [{
                type: Input
            }], message: [{
                type: Input
            }] } });

class BlockUiDirective {
    get ycBlockUi() {
        return this._ycBlockUi;
    }
    set ycBlockUi(value) {
        this._ycBlockUi = value;
        this.setBlockUi();
    }
    constructor(elementRef, i18n) {
        this.elementRef = elementRef;
        this.i18n = i18n;
    }
    setBlockUi() {
        const element = this.elementRef.nativeElement;
        element.ariaLive = 'polite';
        if (this.ycBlockUi) {
            element.ariaBusy = 'true';
            element.ariaLabel = this.i18n.translate('common:textLoading', {}, 'Loading');
            element.classList.add('loading');
        }
        else {
            element.ariaBusy = 'false';
            element.ariaLabel = '';
            element.classList.remove('loading');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockUiDirective, deps: [{ token: i0.ElementRef }, { token: i2.I18nService }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: BlockUiDirective, selector: "[ycBlockUi]", inputs: { ycBlockUi: "ycBlockUi" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockUiDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ycBlockUi]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i2.I18nService }], propDecorators: { ycBlockUi: [{
                type: Input
            }] } });

class BlockUiModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockUiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BlockUiModule, declarations: [BlockUiComponent,
            BlockUiDirective], imports: [CommonModule,
            NotifierModule,
            I18nModule], exports: [BlockUiComponent,
            BlockUiDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockUiModule, imports: [CommonModule,
            NotifierModule,
            I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BlockUiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        NotifierModule,
                        I18nModule
                    ],
                    declarations: [
                        BlockUiComponent,
                        BlockUiDirective
                    ],
                    exports: [
                        BlockUiComponent,
                        BlockUiDirective
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BlockUiComponent, BlockUiDirective, BlockUiModule };
